<template>
  <div>
    <v-menu offset-y>
      <v-btn
        small
        slot="activator"
        :class="{ primary: period.year, 'lighten-1': period.year }"
        flat
      >
        <span v-if="period.year === null">{{ $t('Año') }}</span>
        <span v-else>{{ $t(period.year) }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
      <v-list>
        <!-- <v-list-tile @click="period.year = year">
                            <v-list-tile-title>{{$t('')}}</v-list-tile-title>
                        </v-list-tile> -->
        <v-list-tile v-for="(year, index) in yearRange" :key="index" @click="period.year = year">
          <v-list-tile-title>{{ year }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-menu offset-y>
      <v-btn
        small
        slot="activator"
        :class="{ primary: period.trimester, 'lighten-1': period.trimester }"
        flat
      >
        <span v-if="period.trimester === null">{{ $t('Trimestre') }}</span>
        <span v-else>{{ $t('T' + period.trimester) }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="setTrimester(null)">
          <v-list-tile-title class="font-italic">{{ $t('No filtrar') }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-for="(trimester, index) in trimesterRange"
          :key="index"
          @click="setTrimester(trimester)"
        >
          <v-list-tile-title>{{ $t('T' + trimester) }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <br class="hidden-sm-and-up" />
    <v-menu offset-y>
      <v-btn
        small
        slot="activator"
        :class="{ primary: period.startMonth, 'lighten-1': period.startMonth }"
        flat
      >
        <span v-if="period.startMonth === null">{{ $t('Desde (mes)') }}</span>
        <span v-else>{{ $t(monthRange[period.startMonth - 1]) }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="setStartMonth(null)">
          <v-list-tile-title class="font-italic">{{ $t('No filtrar') }}</v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-for="(month, index) in monthRange"
          :key="index"
          @click="setStartMonth(index + 1)"
        >
          <v-list-tile-title>{{ $t(month) }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
    <v-menu offset-y>
      <v-btn
        small
        slot="activator"
        :class="{ primary: period.endMonth, 'lighten-1': period.endMonth }"
        flat
      >
        <span v-if="period.endMonth === null">{{ $t('Hasta (mes)') }}</span>
        <span v-else>{{ $t(monthRange[period.endMonth - 1]) }}</span>
        <v-icon>mdi-menu-down</v-icon>
      </v-btn>
      <v-list>
        <v-list-tile @click="setEndMonth(null)">
          <v-list-tile-title class="font-italic">{{ $t('No filtrar') }}</v-list-tile-title>
        </v-list-tile>
        <template v-for="(month, index) in monthRange">
          <v-list-tile
            v-if="!period.startMonth || period.startMonth < index + 1"
            :key="index"
            @click="setEndMonth(index + 1)"
          >
            <v-list-tile-title>{{ $t(month) }}</v-list-tile-title>
          </v-list-tile>
        </template>
      </v-list>
    </v-menu>
    <div v-if="error" class="error--text">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    // must not be arrow functions.
    // the name getter
    name() {
      return this.label;
    },
    // the value getter
    value() {
      return this.value; // `this` is the component instance, `value` is the prop we added.
    },
  },
  props: {
    label: {
      type: String,
    },
    value: {
      type: Object,
      default() {
        return {
          year: null,
          trimester: null,
          startMonth: null,
          endMonth: null,
        };
      },
    },
    fromYear: {
      type: [String, Number],
      default: new Date().getFullYear() - 4,
    },
    toYear: {
      type: [String, Number],
      default: new Date().getFullYear(),
    },
    error: {
      type: String,
    },
  },
  computed: {
    yearRange() {
      let res = [];
      for (let i = this.fromYear; i <= this.toYear; i++) {
        res.push(i);
      }
      const month = new Date().getMonth() + 1;
      // If it is november or december we add the next year in the range
      if (month >= 11) {
        res.push(this.toYear + 1);
      }
      return res;
    },
  },
  data() {
    return {
      period: this.value,
      trimesterRange: [1, 2, 3, 4],
      monthRange: [
        'Enero',
        'Febrero',
        'Marzo',
        'Abril',
        'Mayo',
        'Junio',
        'Julio',
        'Agosto',
        'Septiembre',
        'Octubre',
        'Noviembre',
        'Diciembre',
      ],
    };
  },
  methods: {
    setTrimester(trimester) {
      this.period.trimester = trimester;
      if (trimester) {
        this.period.endMonth = trimester * 3;
        this.period.startMonth = trimester * 3 - 2;
      } else {
        this.period.endMonth = null;
        this.period.startMonth = null;
      }
    },
    setStartMonth(month) {
      if (this.period.endMonth && month >= this.period.endMonth) {
        this.period.endMonth = null;
      }
      this.period.trimester = null;
      this.period.startMonth = month;
    },
    setEndMonth(month) {
      this.period.trimester = null;
      this.period.endMonth = month;
    },
  },
  watch: {
    period: {
      handler: function(val, oldVal) {
        if (
          val.year !== oldVal.year ||
          val.startMonth !== oldVal.startMonth ||
          val.endMonth !== oldVal.endMonth
        ) {
          console.log('PRIMER IF');

          if (this.period.year && this.period.startMonth && this.period.endMonth) {
            console.log('SEGUNDO IF');
            this.$emit('input', this.period);
          } else if (this.period.year && !this.period.startMonth && !this.period.endMonth) {
            console.log('Tercer IF');
            this.$emit('input', this.period);
          }
        }
      },
      deep: true,
    },
  },
};
</script>

<style></style>
